import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAsiw5hjtiiA6DviWpBbPzoywbrd2McO7U",
  authDomain: "challenge-e1213.firebaseapp.com",
  databaseURL: "https://challenge-e1213.firebaseio.com",
  projectId: "challenge-e1213",
  storageBucket: "challenge-e1213.appspot.com",
  messagingSenderId: "804282376368",
  appId: "1:804282376368:web:9badcf0ad9eac756c69b75"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
